<script>
  import http from '@/service/http'
  import { mapState } from 'vuex'

  export default {
    name: 'Form',
    data () {
      return {
        categorias: [{}],
        contas: [{}],
        formas: [{}],
        fornecedores: [{}],
        vencimento: false,
        periodicidade: [{id: 'dia', periodo: 'Diariamente'}, {id: 'semana', periodo: 'Semanalmente'}, {
          id: 'quinzena',
          periodo: 'Quinzenalmente'
        }, {id: 'mes', periodo: 'Mensalmente'}, {id: 'bimestre', periodo: 'Bimestralmente'}, {
          id: 'trimestre',
          periodo: 'Trimestralmente'
        }, {id: 'semestre', periodo: 'Semestralmente'}, {id: 'ano', periodo: 'Anualmente'}],
        conta: {
          id: '',
          categoria_id: '',
          conta_id: '',
          forma_id: '',
          fornecedor_id: '',
          descricao: '',
          observacoes: '',
          vencimento: '',
          valor: '',
          pago: false,
          data_pagamento: '',
          desconto: 0,
          juros: 0,
          valor_pago: '',
          repetir: false,
          periodicidade: 'mes',
          vezes: 1,
          anexos: [],
          anexo: ''
        },
        progress: 0,
        errorFile: false,
        options: {
          url: `${process.env.API_URL}/upload-image`,
          uploadMultiple: false,
          acceptedFiles: 'image/*',
          headers: {
            path: 'financeiro',
            width: 2000,
            height: 2000,
            accept: 'all'
          }
        }
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      }
    },
    methods: {
      totalProgress (progress, totalBytes, bytesSent) {
        this.progress = progress
      },
      complete (files, status, xhr) {
        if (files.errorMessage) {
          this.errorFile = true
        } else {
          this.errorFile = false
          this.conta.anexos.push({anexo: xhr.response, legenda: files.name})
          this.$nextTick(() => {
            window.Materialize.updateTextFields()
          })
          this.progress = 0
        }
      },
      destroyAnexo (indexAnexo) {
        this.$swal({
          title: 'Atenção',
          text: `excluir uma anexo é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.conta.anexos[indexAnexo].id) {
            this.conta.anexos.splice(indexAnexo, 1)
            window.Materialize.toast('Anexo excluído!', 4000)
          } else {
            http.delete(`financeiro/pagar/anexo/${this.conta.anexos[indexAnexo].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Anexo excluído!', 4000)
                this.conta.anexos.splice(indexAnexo, 1)
              })
          }
        })
      },
      destroyImage () {
        this.$swal({
          title: 'Atenção',
          text: `deseja excluir a imagem?`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          this.conta.anexo = ''
        })
      },
      async fecth () {
        this.clear()
        const {id} = this.$route.params
        if (id !== undefined) {
          const {data} = await http.get(`/financeiro/pagar/${id}/edit`)
          this.conta = data.conta
          this.categorias = data.categorias
          this.contas = data.contas
          this.formas = data.formas
          this.fornecedores = data.fornecedores
        } else {
          const {data} = await http.get(`/financeiro/pagar/create`)
          this.categorias = data.categorias
          this.contas = data.contas
          this.formas = data.formas
          this.fornecedores = data.fornecedores
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      validate () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            return false
          } else {
            this.submit()
          }
        })
      },
      async submit () {
        const verb = this.isNew ? 'post' : 'put'
        const url = this.isNew ? '/financeiro/pagar' : `/financeiro/pagar/${this.conta.id}`
        const {data} = await http[verb](url, this.conta)
        if (data != null) {
          this.$emit('update-financeiro-pagar-list', {conta: data.conta})
          this.$router.push({name: 'financeiro-pagar.index'})
        }
      },
      clear () {
        this.conta = {
          id: '',
          categoria_id: '',
          conta_id: '',
          forma_id: '',
          fornecedor_id: '',
          descricao: '',
          observacoes: '',
          vencimento: '',
          valor: '',
          pago: false,
          anexos: [],
          data_pagamento: '',
          desconto: 0,
          juros: 0,
          valor_pago: '',
          repetir: false,
          periodicidade: 'mes',
          vezes: 1,
          anexo: ''
        }
      }
    },
    computed: {
      ...mapState(['loading']),
      isNew () {
        return this.conta.id === ''
      },
      api_url () {
        return process.env.UPLOADS_URL
      },
      valorpago () {
        if (this.conta.valor) {
          return (parseFloat(this.conta.valor) + parseFloat(this.conta.juros)) - parseFloat(this.conta.desconto)
        } else {
          return parseFloat(this.conta.juros) - parseFloat(this.conta.desconto)
        }
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">
            <div class="input-field col s12 m4">
              <input name="descricao" id="descricao" type="text" v-validate data-vv-rules="required"
                     :class="{invalid: errors.has('descricao')}" v-model="conta.descricao">
              <label for="descricao">*Descrição</label>
              <small class="red-text">{{ errors.first('descricao') }}</small>
            </div>
            <div class="col s12 m4">
              <label for="categoria_id">*Categoria</label>
              <select name="categoria_id" id="categoria_id" v-validate data-vv-rules="required"
                      :class="{invalid: errors.has('categoria_id')}" v-model="conta.categoria_id">
                <option v-for="categoria in categorias" :value="categoria.id">{{ categoria.categoria }}</option>
              </select>
              <small class="red-text">{{ errors.first('categoria_id') }}</small>
            </div>
            <div class="col s12 m4">
              <label for="fornecedor_id">Fornecedor</label>
              <select name="fornecedor_id" id="fornecedor_id" v-model="conta.fornecedor_id">
                <option v-for="fornecedor in fornecedores" :value="fornecedor.id">{{ fornecedor.fornecedor }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col s12 m3">
              <label for="conta_id">*Conta</label>
              <select name="conta_id" id="conta_id" v-validate data-vv-rules="required"
                      :class="{invalid: errors.has('conta_id')}" v-model="conta.conta_id">
                <option v-for="conta in contas" :value="conta.id">{{ conta.conta }}</option>
              </select>
              <small class="red-text">{{ errors.first('conta_id') }}</small>
            </div>
            <div class="col s12 m3">
              <label for="forma_id">*Forma de Pagamento</label>
              <select name="forma_id" id="forma_id" v-validate data-vv-rules="required"
                      :class="{invalid: errors.has('forma_id')}" v-model="conta.forma_id">
                <option v-for="forma in formas" :value="forma.id">{{ forma.forma }}</option>
              </select>
              <small class="red-text">{{ errors.first('forma_id') }}</small>
            </div>
            <div class="input-field col s12 m3">
              <i class="material-icons prefix">event</i>
              <input name="vencimento" id="icon_vencimento" type="date" v-validate
                     data-vv-rules="required" :class="{invalid: errors.has('vencimento')}" v-model="conta.vencimento"
                     :data-value="conta.vencimento">
              <label for="icon_vencimento" class="active">*Vencimento</label>
              <small class="red-text">{{ errors.first('vencimento') }}</small>
            </div>
            <div class="input-field col s12 m3">
              <input name="valor" id="valor" type="number" step="any" min="0" v-validate data-vv-rules="required"
                     :class="{invalid: errors.has('valor')}" v-model="conta.valor">
              <label for="valor">*Valor</label>
              <small class="red-text">{{ errors.first('valor') }}</small>
            </div>
          </div>

          <div class="row" v-show="isNew">
            <div class="col s12 m2">
              <div class="input-field col s12 m2">
                <input name="repetir" id="repetir" type="checkbox" v-model="conta.repetir">
                <label for="repetir">Repetir</label>
              </div>
            </div>
            <div class="col s12 m4" v-show="conta.repetir">
              <label for="periodicidade">Periodicidade</label>
              <select name="periodicidade" id="periodicidade" v-model="conta.periodicidade">
                <option v-for="periodo in periodicidade" :value="periodo.id">{{ periodo.periodo }}</option>
              </select>
            </div>
            <div class="input-field col s12 m2" v-show="conta.repetir">
              <input name="vezes" id="vezes" type="text" v-model="conta.vezes">
              <label for="vezes">Nº de Vezes</label>
              <small class="red-text">{{ errors.first('vezes') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="col s12">
              <div class="input-field col s12">
                <input name="pago" id="pago" type="checkbox" v-model="conta.pago">
                <label for="pago">Pago</label>
              </div>
            </div>
          </div>

          <div class="row" v-show="conta.pago">

            <div class="input-field col s12 m3">
              <i class="material-icons prefix">event</i>
              <input name="data_pagamento" id="icon_data_pagamento" type="date" v-validate="conta.pago === true ? 'required' : ''" :class="{invalid: errors.has('data_pagamento')}"
                     v-model="conta.data_pagamento" :data-value="conta.data_pagamento">
              <label for="icon_data_pagamento" class="active">*Data Pagamento</label>
              <small class="red-text">{{ errors.first('data_pagamento') }}</small>
            </div>

            <div class="input-field col s12 m3">
              <input name="desconto" id="desconto" type="number" step="any" min="0" v-validate data-vv-rules="required"
                     :class="{invalid: errors.has('desconto')}" v-model="conta.desconto">
              <label for="desconto">*Desconto</label>
              <small class="red-text">{{ errors.first('desconto') }}</small>
            </div>

            <div class="input-field col s12 m3">
              <input name="juros" id="juros" type="number" step="any" min="0" v-validate data-vv-rules="required"
                     :class="{invalid: errors.has('juros')}" v-model="conta.juros">
              <label for="juros">*Juros</label>
              <small class="red-text">{{ errors.first('juros') }}</small>
            </div>

            <div class="input-field col s12 m3">
              <input type="number" id="valorpago" step="any" min="0" v-model="valorpago" readonly="readonly">
              <label for="valorpago">*Valor Pago</label>
            </div>

          </div>

          <div class="row">
            <div class="col s12 m6 center-align" v-for="(anexo, indexAnexo) in conta.anexos">
              <div class="row">
                <div class="col s12 m2">
                  <br>
                  <a :href="`${api_url}/financeiro/${anexo.anexo}`" target="_blank"><i class="material-icons">file_download</i></a>
                </div>
                <div class="input-field col s12 m7">
                  <input name="legenda" :id="`legenda-${indexAnexo}`" type="text"
                         v-model="anexo.legenda"/>
                  <label :for="`legenda-${indexAnexo}`">Legenda</label>
                </div>
                <div class="col s12 m2">
                  <br>
                  <a href="#" @click.prevent="destroyAnexo(indexAnexo)">
                    <i class="material-icons red-text">delete_forever</i>
                  </a>
                </div>
              </div>
              <br clear="all"/>
            </div>
          </div>

          <div class="row">

            <div class="col s12 m3">

              <vue-clip :options="options" :on-complete="complete" :on-total-progress="totalProgress">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card center">
                          <span class="card-title">Anexo</span>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress}%`"></div>
                      </div>
                      <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                      <div v-if="conta.anexo" class="center-align">
                        <i class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i>
                        <a :href="`${api_url}/financeiro/${conta.anexo}`" target="_blank"><i
                          class="material-icons pointer">search</i></a>
                      </div>
                    </div>
                  </div>
                </template>
              </vue-clip>

            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/financeiro/pagar/form.vue